// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pk_a bhk_ea bhk_kb bhk_js bhk_a bhk_j bhk_sm bhk_sn","SearchPanel__icon":"pk_b bhk_vm bhk_hg bhk_ss bhk_uy","SearchPanel__input":"pk_c bhk_iz bhk_eb bhk_z"};